import { createAsyncThunk } from '@reduxjs/toolkit';
import { addLoading, removeLoading } from '../appAction';
import { Enums, Value } from '@utils/constants';
import paths from '@utils/constants/paths';
import { axios } from '@utils/lib';
import { IListRes } from '@interfaces/apis/response-data';
import {
  EnableBoxPayload,
  ISecurityBox,
  ISecurityBoxItem,
  OpenBoxPayload,
  UpdateNameSecurityBoxPayload,
} from '@interfaces/components/securityBox';

export const getSecurityBoxListAsync = createAsyncThunk(
  'security-box/search-by-tenant-id',
  async (query: IBaseQuery, { rejectWithValue, dispatch }) => {
    dispatch(addLoading());
    const searchQuery: Record<string, string> = {
      page: String(query.page ?? Value.TABLE_PAGE_INIT),
    };
    if (query.pageSize) searchQuery.pageSize = query.pageSize;
    const params = new URLSearchParams(searchQuery).toString();
    try {
      const { data } = await axios.request<IListRes<ISecurityBox>>(
        Enums.HTTP_METHOD.GET,
        paths.SECURITY_BOX_BY_TENANT + '?' + params
      );
      return data;
    } catch (error) {
      return rejectWithValue(error);
    } finally {
      dispatch(removeLoading());
    }
  }
);

export const getBoxesBySecurityBoxAsync = createAsyncThunk(
  'boxes-by-security-box',
  async (securityBoxId: string, { rejectWithValue, dispatch }) => {
    dispatch(addLoading());
    try {
      const { data } = await axios.request<IListRes<ISecurityBoxItem>>(
        Enums.HTTP_METHOD.GET,
        paths.BOXES_BY_SECURITY_BOX.replace(':id', securityBoxId)
      );
      return data;
    } catch (error) {
      return rejectWithValue(error);
    } finally {
      dispatch(removeLoading());
    }
  }
);

export const enableBoxAsync = createAsyncThunk(
  'api/box/enable-box',
  async (body: EnableBoxPayload, { rejectWithValue, dispatch }) => {
    dispatch(addLoading());
    try {
      const { data } = await axios.request(
        Enums.HTTP_METHOD.PUT,
        paths.ENABLE_BOX,
        body
      );
      return data;
    } catch (error) {
      return rejectWithValue(error);
    } finally {
      dispatch(removeLoading());
    }
  }
);

export const openBoxAsync = createAsyncThunk(
  'api/box/open-box',
  async (body: OpenBoxPayload, { rejectWithValue, dispatch }) => {
    dispatch(addLoading());
    try {
      const { data } = await axios.request(
        Enums.HTTP_METHOD.POST,
        paths.OPEN_BOX,
        body
      );
      return data;
    } catch (error) {
      return rejectWithValue(error);
    } finally {
      dispatch(removeLoading());
    }
  }
);

export const updateLockerNameAsync = createAsyncThunk(
  'api/security-box/update',
  async (body: UpdateNameSecurityBoxPayload, { rejectWithValue, dispatch }) => {
    dispatch(addLoading());
    try {
      const { id, lockerName } = body;

      const { data } = await axios.request(
        Enums.HTTP_METHOD.PATCH,
        paths.UPDATE_NAME_USECURITY_BOX.replace(':id', String(id)),
        { lockerName }
      );
      return data;
    } catch (error) {
      return rejectWithValue(error);
    } finally {
      dispatch(removeLoading());
    }
  }
);
